(function(angular) {
    'use strict';
    angular.module('um.commonDirectives').directive('inputDecorator', function() {
        return {
            require: 'ngModel',
            link: function($scope, element, $attrs, ngModelController) {
                ngModelController.$parsers.push(function(data) {
                    return data && $attrs.inputDecorator + data;
                });

                ngModelController.$formatters.push(function(data) {
                    if (data && angular.isString($attrs.inputDecorator)) {
                        data = data.replace(new RegExp($attrs.inputDecorator), '');
                    }
                    return data;
                });
            }
        }
    });
})(window.angular);
